import { getCachedObject } from 'data/hooks/objects/objectOperations'

/**
 * Gets the current schema timestamp
 */
export const getSchemaTimestamp = (objectId: string): number | undefined => {
    return getCachedObject(objectId)?.schemaTimestamp
}
